import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BluechatDelivery } from '../../shared/bluechat-delivery.model';
import { BluechatService } from '../../bluechat.service';
import { BluechatLoadStatus } from '../../shared/bluechat-load.model';
import { NavigationLinkService } from '../../../shared/services/navigation-link.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { StopType } from '../../../shared/stop-type.model';


@Component({
  selector: 'app-bluechat-delivery-detail',
  templateUrl: './bluechat-delivery-detail.component.html',
  styleUrls: ['./bluechat-delivery-detail.component.scss']
})
export class BluechatDeliveryDetailPopupComponent implements OnInit {

  @Input() public delivery: BluechatDelivery;
  @Input() public userCanCreateNote = false;
  @Input() public loadStatusAllowNoteCreation = false;
  @Input() public carrierHasBluechat = false;
  @Input() public loadStatus: BluechatLoadStatus;
  @Output() public createNote = new EventEmitter<void>();

  public dateFormat: string = BluechatService.DATE_FORMAT;
  public loadStatusI18nKey: string;
  public shouldPickArrivalBeInError: boolean;
  public shouldPickDepartureBeInError: boolean;
  public shouldDropArrivalBeInError: boolean;
  public shouldDropDepartureBeInError: boolean;

  canManageLocations = false;
  showEtaDetails = false;
  deliveryNumberForEtaDetails: string;
  destinationTypeForEtaDetails: StopType;
  destinationGlidForEtaDetails: string;
  latestEtaReportIdForEtaDetails: string;

  readonly StopType = StopType;



  constructor(
    private authService: AuthenticationService,
    public link: NavigationLinkService
  ) {
    this.canManageLocations = this.authService.canManageLocations();
  }

  ngOnInit(): void {
    this.loadStatusI18nKey = 'bluechat.load-status.' + this.loadStatus.toLowerCase();

    this.shouldPickArrivalBeInError = !this.delivery.origin.arrivalDateTime && (
        !!this.delivery.destination.arrivalDateTime
        || !!this.delivery.destination.departureDateTime
        || !!this.delivery.origin.departureDateTime
        || this.loadStatus === BluechatLoadStatus.COMPLETED) ;

    this.shouldPickDepartureBeInError = !this.delivery.origin.departureDateTime && (
        !!this.delivery.destination.arrivalDateTime
        || !!this.delivery.destination.departureDateTime
        || this.loadStatus === BluechatLoadStatus.COMPLETED);

    this.shouldDropArrivalBeInError = !this.delivery.destination.arrivalDateTime && (
        !!this.delivery.destination.departureDateTime
        || this.loadStatus === BluechatLoadStatus.COMPLETED);

    this.shouldDropDepartureBeInError = !this.delivery.destination.departureDateTime && this.loadStatus === BluechatLoadStatus.COMPLETED;
  }

  hideEtaDetails() {
    this.showEtaDetails = false;
    this.deliveryNumberForEtaDetails = null;
    this.destinationTypeForEtaDetails = null;
    this.destinationGlidForEtaDetails = null;
    this.latestEtaReportIdForEtaDetails = null;
  }


  showEtaDetailsForDeliveryAndType(deliveryNumber: string, destinationType: StopType, destinationGlid: string, latestEtaReportId: string) {
    this.deliveryNumberForEtaDetails = deliveryNumber;
    this.destinationTypeForEtaDetails = destinationType;
    this.destinationGlidForEtaDetails = destinationGlid;
    this.latestEtaReportIdForEtaDetails = latestEtaReportId;
    this.showEtaDetails = true;
  }
}
